import { render, staticRenderFns } from "./KuaiEdit.vue?vue&type=template&id=61922e1e&scoped=true"
import script from "./KuaiEdit.vue?vue&type=script&lang=js"
export * from "./KuaiEdit.vue?vue&type=script&lang=js"
import style0 from "./KuaiEdit.vue?vue&type=style&index=0&id=61922e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61922e1e",
  null
  
)

export default component.exports